export const DESIRED_JOB_TITLE_DELIMITER = "\u001F";
export const MAX_DESIRED_JOB_TITLES = 3;
export const MAX_DESIRED_JOB_TITLE_LENGTH = 255;
export const MAX_DESIRED_JOB_TITLES_LENGTH = 768;

type Translate = (key: string, options?: Record<string, unknown>) => string;

export const desiredJobTitleValidator =
  (t: Translate) =>
  (_value: string, nextValues: string[]): string | null => {
    if (nextValues.join(DESIRED_JOB_TITLE_DELIMITER).length > MAX_DESIRED_JOB_TITLES_LENGTH) {
      return t("workPreferences.jobTitle.tooLong");
    }

    return null;
  };
